import { Component, Input, Injector, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { first } from 'rxjs/operators';
import moment from 'moment';
import _ from 'lodash';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { SubscriptionDateService } from 'src/app/services/subscription-date.service';
import { DailyMenuDataService } from 'src/app/services/daily-menu-data.service';
import { BasePage } from 'src/app/shared/base-page';

@Component({
  selector: 'app-selection',
  templateUrl: './selection.page.html',
  styleUrls: ['./selection.page.scss'],
  standalone: false,
})
export class SelectionPage extends BasePage implements OnInit {
  @Input() date?: any;
  @Input() customer_id?: any;
  @Input() customer_subscription_id?: any;
  @Input() isDoubleBox?: boolean = false;

  loader: boolean = true;
  menuData: any = {};
  selectedFood: any = [];
  customer?: any;
  storeData?: any;
  today?: any;
  info?: any;
  daysafter?: any;
  dayOff?: number;
  freezeDates: any[] = [];
  minDate: string = '';
  constructor(
    injector: Injector,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private apiService: ApiService,
    private dailyMenuDataService: DailyMenuDataService,
    private subscriptionDateService: SubscriptionDateService,
  ) {
    super(injector);
  }
  ngOnInit() {
    this.configService.appSettings$.subscribe((currentSettings: any) => {
      this.settings = currentSettings;
    });
    const authService = this.getAuthService();
    this.customer = authService?.getAuthUser();
    this.loadSelectedItems();
  }

  ionViewWillEnter() {
  }

  protected override async onPageReady() {
    super.onPageReady();
    
    const authService = this.getAuthService();
    this.customer = authService?.getAuthUser();
    
    if (this.customer?.id) {
      const state = this.subscriptionDateService.getState();
      const config = this.subscriptionDateService.getConfig();
      
      this.daysafter = config?.menu_selection_before || 3;
      this.dayOff = config?.week_day_off || 0;
      this.freezeDates = state.freezeDates;
      this.minDate = state.minDate;
      
    } else {
      console.warn('[SelectionPage] No customer ID available');
    }
  }
  loadSelectedItems = async () => {
    
    this.menuData = {};
    this.selectedFood = [];
    this.loader = true;

    try {
      const state = this.subscriptionDateService.getState();
      const formattedDate = moment(this.date).format('YYYY-MM-DD');
      const dayConfig = state.dayConfigs[formattedDate];
      
      
      const menuResponse = await this.dailyMenuDataService.getMenuData(
        this.customer.id,
        formattedDate,
        this.isDoubleBox || false,
        this.customer,
        dayConfig?.selectionLimit || {}
      );
      
      
      this.loader = false;
      
      if (menuResponse?.newNestedArray) {
        const menuBuilders = menuResponse.newNestedArray;
        
        
        menuBuilders.forEach((builder: any, builderIndex: number) => {
          
          builder.type_data?.forEach((item: any, itemIndex: number) => {
            
            if (item.is_selected || item.quantity > 0) {
              this.selectedFood.push(item);
            }
            
            item.replaceable_menu_items?.forEach((replaceable_menu: any, rIndex: number) => {
       
              
              if (replaceable_menu.is_selected || replaceable_menu.quantity > 0) {
                this.selectedFood.push(replaceable_menu);
              }
            });
          });
        });
        
      } else {
        console.warn('[SelectionPage] No menu data in response');
      }
    } catch (error) {
      console.error('[SelectionPage] Error loading menu:', error);
      this.loader = false;
      this.menuData = {};
    }
  };
  clearMenuApi = async (item: any) => {
    const apiQuery = {
      customer_id: this.customer.id,
      date: moment(this.date).format('YYYY-MM-DD'),
    };
    if (item != null) {
      Object.assign(apiQuery, { selected_menu_item_id: item.selected_menu_item_id });
    }

    this.showLoading();
    let status = false;
    await this.apiService
      .post(endpoints.clearMenu, apiQuery)
      .pipe(first())
      .subscribe(
        (response) => {
          this.hideLoading();
          if (response.code == 201) {
            this.toastMessage(response.message);
            status = true;
            status = false;
          } else {
            this.toastMessage(response.message);
            status = false;
          }
        },
        (_error) => {
          status = false;
        },
      );
    return status;
  };
  clearOne = async (item: any) => {
    if (moment(this.date).format('YYYY-MM-DD') != moment().format('YYYY-MM-DD')) {
      await this.clearMenuApi(item);

      if (true) {
        this.dailyMenuDataService.invalidateDate(moment(this.date).format('YYYY-MM-DD'));
        this.loadSelectedItems();
      }
    } else {
      this.toastMessage('Cant Delete same day menu');
    }
  };
  clearAllSelection = async () => {
    if (moment(this.date).format('YYYY-MM-DD') != moment().format('YYYY-MM-DD')) {
      await this.clearMenuApi(null);

      if (true) {
        this.dailyMenuDataService.invalidateDate(moment(this.date).format('YYYY-MM-DD'));
        this.selectedFood = [];
      }
    } else {
      this.toastMessage('Cant Delete same day menu');
    }
  };
  navigateToMenu = () => {
    this.today = moment().format('YYYY-MM-DD');
    
    const state = this.subscriptionDateService.getState();
    const minDate = state.minDate;
    const selectedDate = moment(this.date).format('YYYY-MM-DD');
    
    if (moment(selectedDate).isSameOrAfter(minDate)) {
      this.modalCtrl?.dismiss({ redirection: true, navigateToMenu: true });
    } else {
      this.toastMessage('Cannot Visit Menu');
    }
  };
  
  private calculateNextAvailableDate(daysAfter: number): string {
    const nextDate = this.subscriptionDateService.getNextAvailableDate(
      moment().format('YYYY-MM-DD'),
      daysAfter
    );
    
    return nextDate || moment().format('YYYY-MM-DD');
  }
  emptyObject = (data: any) => {
    if (Object.entries(data).length > 0) {
      return false;
    }
    return true;
  };
  closeModal = () => {
    this.modalCtrl?.dismiss();
  };
  showLoading = async () => {
    this.loadingCtrl
      .create({
        message: this.translate?.instant('please_wait'),
        cssClass: 'loader_class',
      })
      .then((a: any) => {
        a.present().then(() => {});
      });
  };

  hideLoading = async () => {
    setTimeout(async () => {
      try {
        this.loadingCtrl?.dismiss();
      } catch (error) {}
    }, 1000);
  };

  toastMessage = async (msg: any) => {
    await this.toastCtrl
      .create({
        message: this.translate?.instant(msg),
        duration: 1000,
        position: 'top',
        color: 'light',
      })
      .then((toastElem: any) => toastElem.present());
  };

  getParseFloat = (num: any) => {
    return Number(parseFloat(num).toFixed(0));
  };
  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
